import React, { Component } from "react";
import Header from "../layouts/Header";
import Hero from "./parts/Hero";
import BenefitsSection from "./parts/BenefitsSection";
import CTASection from "./parts/CTASection";
import IntegratedWithSection from "./parts/IntegratedWithSection";
import HowItWorksSection from "./parts/HowItWorksSection";
import CaseStudiesSection from "./parts/CaseStudiesSection";

class Home extends Component {
    // componentDidMount() {
    //     // Inject the stylesheet
    //     const link = document.createElement("link");
    //     link.rel = "stylesheet";
    //     link.href = "https://cdn.jsdelivr.net/npm/@n8n/chat/dist/style.css";
    //     document.head.appendChild(link);
    //
    //     // Inject the script
    //     const script = document.createElement("script");
    //     script.type = "module";
    //     script.textContent = `
    //         import { createChat } from 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';
    //         createChat({
    //             webhookUrl: 'https://brandbounce.app.n8n.cloud/webhook/eb7c04ce-d05f-4cdf-9d6d-8ee8a739eaed/chat'
    //         });
    //     `;
    //     document.body.appendChild(script);
    // }

    render() {
        return (
            <div>
                <Header />
                <Hero />
                <BenefitsSection />
                <CTASection />
                <IntegratedWithSection />
                <HowItWorksSection />
                <CaseStudiesSection />
            </div>
        );
    }
}

export default Home;
